import * as React from "react";
import { callApi } from "../../utils/api";
import { ADMIN_ROLE } from "../../utils/role";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import { ToastsContainer, ToastsContainerPosition, ToastsStore } from "react-toasts";
import moment from "moment";
import Accordion from "react-bootstrap/Accordion";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import isEmpty from 'lodash/isEmpty';
import Select from 'react-select';
import { hasPageAccess } from "../../utils/pagePermissionService";

declare var $: any;
export interface Bank {
    id: number;
    bank_id: number;
    name: string;
}
interface AllProps {
    history: any;
}
class RectifyCategorymanagement extends React.Component<AllProps> {
    state = {
        categorys: [],
        mapCategorys: [],
        categoryToBeDeleted: "",
        categoryMapToBeDeleted: "",
        isFileRefresh: false,
        selectedcategory: {
            id: 0,
            category: "",
        },
        selectedMapCategory: {
            id: 0,
            category: "",
            subCategory: "",
        },
        outreason: "",
        selectVal: false,
        isLoading: false,
        activeTabKey: 'categoryManage',
        rectifyCategorys: [],
        rectifySubCategorys: [],
    };
    async componentDidMount() {
        this.categoryGet(this.state.activeTabKey);
        this.getOutTime();
        const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
        if (!hasHide) {
            this.ouTime();
        }
        this.getRectifyCategorys();
        this.getRectifySubCategorys();
    }
    getRectifyCategorys = () => {
        this.setState({ isFileRefresh: false });
        callApi("GET", "rectify_error_category_get.php")
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                this.setState({ rectifyCategorys: files });
            })
            .catch(err => {
                console.log(err);
            });
    };
    getRectifySubCategorys = () => {
        this.setState({ isFileRefresh: false });
        callApi("GET", "rectify_sub_category_get.php")
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                this.setState({ rectifySubCategorys: files });
            })
            .catch(err => {
                console.log(err);
            });
    };
    categoryGet = (key) => {
        this.setState({ isFileRefresh: false });
        const api = key == 'categoryManage' ? "rectify_category_get.php" : (key == 'subCategoryManage' ? "rectify_sub_category_get.php" : 'rectify_error_category_get.php');
        callApi("GET", api)
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                this.getRectifyCategorys();
                this.getRectifySubCategorys();
                if (files && files.length > 0) {
                    files.forEach((file, index) => {
                        Object.keys(file).forEach(fileKey => {
                            file[fileKey] = !file[fileKey] ? "" : typeof file[fileKey] !== 'string' ? String(file[fileKey]) : file[fileKey];
                        })
                        file.index = index + 1;
                    })
                }
                this.setState({ categorys: files, isFileRefresh: true });
            })
            .catch(err => {
                console.log(err);
            });
    };

    categoryMapGet = () => {
        callApi("GET", "rectify_map_category_get.php")
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                if (files && files.length > 0) {
                    files.forEach((file, index) => {
                        Object.keys(file).forEach(fileKey => {
                            file[fileKey] = !file[fileKey] ? "" : typeof file[fileKey] !== 'string' ? String(file[fileKey]) : file[fileKey];
                        })
                        file.index = index + 1;
                    })
                }
                this.setState({ mapCategorys: files });
            })
            .catch(err => {
                console.log(err);
            });
    }

    addBank = () => {
        this.setState({ selectedcategory: Object.assign({}) });
    };
    addMapCategory = () => {
        this.setState({ selectedMapCategory: Object.assign({}) });
    };
    editBank = (bank: Bank) => {
        this.setState({ selectedcategory: bank });
    };
    editMapCategory = (bank: Bank) => {
        this.setState({ selectedMapCategory: bank });
    };
    saveBank = () => {
        const { activeTabKey } = this.state;
        if (this.state.selectedcategory.id) {
            const api = activeTabKey == 'categoryManage' ? "rectify_category_update.php" : (activeTabKey == 'subCategoryManage' ? "rectify_sub_category_update.php" : 'rectify_error_category_update.php');

            this.state.selectedcategory.id = Number(this.state.selectedcategory.id);
            callApi("POST", api, this.state.selectedcategory)
                .then(res => res.data)
                .then(response => {
                    if (response.success) {
                        $("#category-form").modal("hide");
                        ToastsStore.success("Updated Successfully");
                        this.categoryGet(activeTabKey);
                        this.setState({ selectedcategory: {} });
                    } else {
                        ToastsStore.error(response.message);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        } else {
            const api = activeTabKey == 'categoryManage' ? "rectify_category_create.php" : (activeTabKey == 'subCategoryManage' ? "rectify_sub_category_create.php" : 'rectify_error_category_create.php');

            callApi("POST", api, this.state.selectedcategory)
                .then(res => res.data)
                .then(response => {
                    if (response.success) {
                        $("#category-form").modal("hide");
                        ToastsStore.success("Saved Successfully");
                        this.categoryGet(activeTabKey);
                        this.setState({ selectedcategory: {} });
                    } else {
                        ToastsStore.error(response.message);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    };

    saveMapCategory = () => {
        const { category, subCategory }: any = this.state.selectedMapCategory;
        if (isEmpty(category) || isEmpty(subCategory)) {
            ToastsStore.error("Required Fields are Missing.");
            return;
        }
        if (this.state.selectedMapCategory.id) {
            this.state.selectedMapCategory.id = Number(this.state.selectedMapCategory.id);
            callApi("POST", "rectify_map_category_update.php", this.state.selectedMapCategory)
                .then(res => res.data)
                .then(response => {
                    if (response.success) {
                        ToastsStore.success("Updated Successfully");
                        $("#map-category-form").modal("hide");
                        this.categoryMapGet();
                        this.setState({ selectedMapCategory: {} });
                    } else {
                        ToastsStore.error(response.message);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        } else {
            callApi("POST", "rectify_map_category_create.php", this.state.selectedMapCategory)
                .then(res => res.data)
                .then(response => {
                    if (response.success) {
                        ToastsStore.success("Saved Successfully");
                        $("#map-category-form").modal("hide");
                        this.categoryMapGet();
                        this.setState({ selectedMapCategory: {} });
                    } else {
                        ToastsStore.error(response.message);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    };

    confirmDeleteBank = (modal: Bank) => {
        this.setState({ categoryToBeDeleted: modal.id });
    };

    confirmDeleteMapCategory = (modal: Bank) => {
        this.setState({ categoryMapToBeDeleted: modal.id });
    };

    deleteBank = () => {
        const { activeTabKey } = this.state;
        const api = activeTabKey == 'categoryManage' ? "rectify_category_delete.php" : (activeTabKey == 'subCategoryManage' ? "rectify_sub_category_delete.php" : 'rectify_error_category_delete.php');

        callApi("POST", api, { id: this.state.categoryToBeDeleted })
            .then(res => res.data)
            .then(response => {
                this.categoryGet(activeTabKey);
            })
            .catch(err => {
                console.log(err);
            });
    };

    deleteMapCategory = () => {
        callApi("POST", "rectify_map_category_delete.php", { id: this.state.categoryMapToBeDeleted })
            .then(res => res.data)
            .then(response => {
                this.categoryMapGet();
            })
            .catch(err => {
                console.log(err);
            });
    };
    handleChange = (e: any) => {
        const bankdetail: any = this.state.selectedcategory;
        bankdetail[e.target.name] = e.target.value;
        this.setState({ bankdetail });
    };
    handleMapCategoryChange = (e: any, propName?, fieldType?) => {
        let fieldName = fieldType === 'singleselect' ? propName : e.target.name;
        let fieldValue = fieldType === 'singleselect' ? e.value : e.target.value;

        const selectedMapCategory: any = this.state.selectedMapCategory;
        selectedMapCategory[fieldName] = fieldValue;
        this.setState({ selectedMapCategory });
    };
    previousPop = () => {
        $("#out_reason").modal("show");
        $("#another-reason").modal("hide");
    }
    BacktoFile = () => {
        $("#out_reason").modal("hide");
        const fileid1: any = localStorage.getItem("currentfileId");

        this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
    }
    getOutTime = () => {
        let date = new Date();
        let stratTime = date.getTime();
        localStorage.setItem("startTime", JSON.stringify(stratTime))
        let outDate = date.toLocaleDateString();
        localStorage.setItem("OutDateGet", JSON.stringify(outDate));
        var Railway = date.getMinutes();
        if (Railway < 10) {
            var TotalMinutes = "0" + Railway;
            let ouTtime = date.getHours() + ":" + TotalMinutes;
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
        else {
            let ouTtime: any = date.getHours() + ":" + date.getMinutes();
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }

    }
    ouTime = () => {
        const getfileId: any = localStorage.getItem("currentfileId");
        if (localStorage.getItem("currentfileId")) {
            $("#out_reason").modal("show");
        }
    }
    outimeGet = () => {
        this.setState({ isLoading: true });
        const fileid1: any = localStorage.getItem("currentfileId");
        const userid1: any = localStorage.getItem("user1");
        const inreason: any = localStorage.getItem("in_reason");
        const intime: any = localStorage.getItem("IntimeGet");
        const outtime: any = localStorage.getItem("outtimeGet");
        const outdate: any = localStorage.getItem("OutDateGet");
        const secondsSpent = moment(outtime, "HH:mm").diff(moment(intime, "HH:mm"), 'seconds');
        const insertId: any = localStorage.getItem("ProcessEodInsertID");
        if (this.state.outreason == "") {
            this.setState({ selectVal: true });
        }
        else {
            let obj = {
                "file_id": JSON.parse(fileid1),
                "user_id": JSON.parse(userid1),
                "in_reason": JSON.parse(inreason),
                "out_reason": this.state.outreason,
                "intime": JSON.parse(intime),
                "outtime": JSON.parse(outtime),
                "insert_date": JSON.parse(outdate),
                "total_seconds": secondsSpent,
                "insert_id": insertId
            }

            callApi("POST", "process_eod_insert.php", obj)
                .then(res => res.data)
                .then(response => {
                    this.setState({ isLoading: false });
                    localStorage.removeItem("in_reason");
                    localStorage.removeItem("outreason");
                    localStorage.removeItem("IntimeGet");
                    localStorage.removeItem("OutDateGet");
                    localStorage.removeItem('currentfileId');
                    $("#out_reason").modal("hide");
                    $("#another-reason").modal("hide");
                    ToastsStore.success("Your Reason Saved Successfully");
                }).catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                    ToastsStore.error("Your Reason Not Stored");
                })
        }
    }

    onchangeReason = (e: any) => {

        if (e.target.value == "Other") {
            this.setState({ in_reason: "", selectVal: false })
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        }
        else if (e.target.value == "select") {
            this.setState({ setResponse: false })
        }
        else {
            this.setState({ [e.target.name]: e.target.value, selectVal: false });
        }
    };

    onchange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value.replace(/\s+/g, ' ').trim(), selectVal: false });
    };
    render() {
        const user: any = localStorage.getItem("user");
        const role_id = user ? JSON.parse(user)["role_id"] : "";
        const { activeTabKey } = this.state;
        const columns = [
            {
                header: 'ID',
                key: 'index',
            },
            {
                header: activeTabKey == 'categoryManage' ? 'Category' : (activeTabKey == 'subCategoryManage' ? 'Place of Error (Subdivision)' : "Place of Error"),
                key: 'category',
            },
            {
                header: "Actions",
                td: (file) => {
                    return <div className="btn-group mb-2 mr-2">
                        <button
                            type="button"
                            className="btn btn-primary"
                        >
                            Action
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span className="sr-only">
                                Toggle Dropdown
                            </span>
                        </button>
                        <div
                            className="dropdown-menu"
                            x-placement="top-start"
                            style={{
                                position: "absolute",
                                top: "0px",
                                left: "0px",
                                transform:
                                    "translate3d(88px, -2px, 0px)"
                            }}
                        >
                            <a
                                className="dropdown-item"
                                data-toggle="modal"
                                data-target="#category-form"
                                onClick={() =>
                                    this.editBank(file)
                                }
                            >
                                Edit
                            </a>
                            {role_id === ADMIN_ROLE && (
                                <a
                                    className="dropdown-item"
                                    style={{ float: "right" }}
                                    data-toggle="modal"
                                    data-target="#delete-bank"
                                    onClick={() =>
                                        this.confirmDeleteBank(file)
                                    }
                                >
                                    Delete
                                </a>
                            )}
                        </div>
                    </div>
                }
            }
        ];
        const mapCategoryColumns = [
            {
                header: 'ID',
                key: 'index',
            },
            {
                header: "Category",
                key: 'category_name',
            },
            {
                header: "Sub Category",
                key: 'subCategory_name',
            },
            {
                header: "Actions",
                td: (file) => {
                    return <div className="btn-group mb-2 mr-2">
                        <button
                            type="button"
                            className="btn btn-primary"
                        >
                            Action
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span className="sr-only">
                                Toggle Dropdown
                            </span>
                        </button>
                        <div
                            className="dropdown-menu"
                            x-placement="top-start"
                            style={{
                                position: "absolute",
                                top: "0px",
                                left: "0px",
                                transform:
                                    "translate3d(88px, -2px, 0px)"
                            }}
                        >
                            <a
                                className="dropdown-item"
                                data-toggle="modal"
                                data-target="#map-category-form"
                                onClick={() =>
                                    this.editMapCategory(file)
                                }
                            >
                                Edit
                            </a>
                            {role_id === ADMIN_ROLE && (
                                <a
                                    className="dropdown-item"
                                    style={{ float: "right" }}
                                    data-toggle="modal"
                                    data-target="#delete-map-category"
                                    onClick={() =>
                                        this.confirmDeleteMapCategory(file)
                                    }
                                >
                                    Delete
                                </a>
                            )}
                        </div>
                    </div>
                }
            }
        ];
        const data = this.state.categorys;
        const dataMapCategory = this.state.mapCategorys;
        return (
            <section className="pcoded-main-container">
                <ToastsContainer
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_RIGHT}
                />{" "}
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5>Rectification Category Manage</h5>
                                                    <button
                                                        className="btn btn-primary"
                                                        style={{ float: "right" }}
                                                        onClick={() => this.props.history.goBack()}
                                                    >
                                                        Back
                                                    </button>
                                                </div>
                                                <div className="card-body">
                                                    <Accordion className="mainAccordion">
                                                        <Tabs
                                                            defaultActiveKey="categoryManage"
                                                            onSelect={(key) => {
                                                                this.setState({ activeTabKey: key });
                                                                if (key != "mapCategoryManage") {
                                                                    this.categoryGet(key);
                                                                } else {
                                                                    this.categoryMapGet();
                                                                }
                                                            }}
                                                        >
                                                            <Tab
                                                                eventKey="categoryManage"
                                                                title="Error Type"
                                                                key={`category`}
                                                            >
                                                                <div className="dt-responsive table-responsive">
                                                                    <a
                                                                        className="btn btn-primary m-b-20"
                                                                        data-toggle="modal"
                                                                        data-target="#category-form"
                                                                        onClick={this.addBank}
                                                                    >
                                                                        + Add Category
                                                                    </a>

                                                                    {this.state.isFileRefresh && data.length > 0 &&
                                                                        <ReactFlexyTable data={data} columns={columns} sortable globalSearch />
                                                                    }
                                                                </div>
                                                            </Tab>
                                                            <Tab
                                                                eventKey="errorCategoryManage"
                                                                title="Place of Error"
                                                                key={`errorCategory`}
                                                            >
                                                                <div className="dt-responsive table-responsive">
                                                                    <a
                                                                        className="btn btn-primary m-b-20"
                                                                        data-toggle="modal"
                                                                        data-target="#category-form"
                                                                        onClick={this.addBank}
                                                                    >
                                                                        + Add Place of Error
                                                                    </a>

                                                                    {this.state.isFileRefresh && data.length > 0 &&
                                                                        <ReactFlexyTable data={data} columns={columns} sortable globalSearch />
                                                                    }
                                                                </div>
                                                            </Tab>
                                                            <Tab
                                                                eventKey="subCategoryManage"
                                                                title="Place of Error (Subdivision)"
                                                                key={`subCategory`}
                                                            >
                                                                <div className="dt-responsive table-responsive">
                                                                    <a
                                                                        className="btn btn-primary m-b-20"
                                                                        data-toggle="modal"
                                                                        data-target="#category-form"
                                                                        onClick={this.addBank}
                                                                    >
                                                                        + Add Place of Error (Subdivision)
                                                                    </a>

                                                                    {this.state.isFileRefresh && data.length > 0 &&
                                                                        <ReactFlexyTable data={data} columns={columns} sortable globalSearch />
                                                                    }
                                                                </div>
                                                            </Tab>

                                                            <Tab
                                                                eventKey="mapCategoryManage"
                                                                title="Category + Sub Category"
                                                                key={`mapCategory`}
                                                            >
                                                                <div className="dt-responsive table-responsive">
                                                                    <a
                                                                        className="btn btn-primary m-b-20"
                                                                        data-toggle="modal"
                                                                        data-target="#map-category-form"
                                                                        onClick={this.addMapCategory}
                                                                    >
                                                                        + Add
                                                                    </a>

                                                                    {this.state.isFileRefresh && dataMapCategory.length > 0 &&
                                                                        <ReactFlexyTable data={dataMapCategory} columns={mapCategoryColumns} sortable globalSearch />
                                                                    }
                                                                </div>
                                                            </Tab>
                                                        </Tabs>
                                                    </Accordion>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="category-form"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label className="col-form-label">Category:</label>{" "}
                                                <input
                                                    type="text"
                                                    name="category"
                                                    className="form-control"
                                                    placeholder=""
                                                    onChange={e => {
                                                        this.handleChange(e);
                                                    }}
                                                    value={
                                                        this.state.selectedcategory.category
                                                            ? this.state.selectedcategory.category
                                                            : ""
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    // data-dismiss="modal"
                                    onClick={this.saveBank}
                                >
                                    {isEmpty(this.state.selectedcategory.id) ? "Save" : "Update"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="map-category-form"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label className="col-form-label">Place of Error Category<span style={{ color: "red" }}>*</span></label>{" "}
                                                {this.state.rectifyCategorys && this.state.rectifyCategorys.length > 0 && this.state.rectifyCategorys.map((opt: any) => {
                                                    opt.label = opt.category; opt.value = opt.id
                                                }) &&
                                                    <Select options={[{ label: "Select...", value: "" }, ...this.state.rectifyCategorys]} name="category" className={this.state.selectedMapCategory.category == '' ? 'form-select is-invalid' : 'form-select'}
                                                        value={this.state.rectifyCategorys.find((o: any) => o.value === this.state.selectedMapCategory.category)}
                                                        onChange={(e) => this.handleMapCategoryChange(e, 'category', 'singleselect')}
                                                    />
                                                }
                                            </div>
                                            <div className="col-md-6">
                                                <label className="col-form-label">Sub-Category<span style={{ color: "red" }}>*</span></label>
                                                {this.state.rectifySubCategorys && this.state.rectifySubCategorys.length > 0 && this.state.rectifySubCategorys.map((opt: any) => {
                                                    opt.label = opt.category; opt.value = opt.id
                                                }) &&
                                                    <Select options={[{ label: "Select...", value: "" }, ...this.state.rectifySubCategorys]} name="subCategory" className={this.state.selectedMapCategory.subCategory == '' ? 'form-select is-invalid' : 'form-select'}
                                                        value={this.state.rectifySubCategorys.find((o: any) => o.value === this.state.selectedMapCategory.subCategory)}
                                                        onChange={(e) => this.handleMapCategoryChange(e, 'subCategory', 'singleselect')}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    // data-dismiss="modal"
                                    onClick={this.saveMapCategory}
                                >
                                    {isEmpty(this.state.selectedcategory.id) ? "Save" : "Update"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="delete-bank"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Delete Category</h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <h6>Are you sure you want to delete this Category?</h6>
                                <div className="form-group">
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                >
                                    No
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    data-dismiss="modal"
                                    onClick={this.deleteBank}
                                >
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="delete-map-category"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Delete Category</h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <h6>Are you sure you want to delete?</h6>
                                <div className="form-group">
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                >
                                    No
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    data-dismiss="modal"
                                    onClick={this.deleteMapCategory}
                                >
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* THIS FOR OUT REASON MODAL */}
                <div className="modal fade hide in" id="out_reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                            <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>
                                <h3 style={{ margin: 'auto', fontSize: '17px' }}>Please Select The Reason For To Close The File.No:{localStorage.getItem("currentfileId")}</h3>
                            </div>
                            <div className="form-group" style={{ width: '74%', margin: 'auto' }}>
                                <select
                                    className="custom-select"
                                    name="outreason"
                                    value={this.state.outreason}
                                    onChange={(e) => this.onchangeReason(e)}
                                    required
                                    id="select1"
                                    style={{ marginTop: '8px' }}
                                >
                                    <option value="select">Select Your Reason</option>
                                    <option value="Query Raised">Query Raised</option>
                                    <option value=" Re-Query Raised"> Re-Query Raised</option>
                                    <option value="Hold ">Hold </option>
                                    <option value="Completed">Completed</option>
                                    <option value="Other">Others</option>

                                </select>
                                {this.state.selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                            </div>
                            <div className="modal-footer" style={{ marginTop: '27px' }}>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isLoading}
                                    onClick={this.outimeGet}
                                    style={{ width: '76px', fontSize: '17px' }}
                                > {this.state.isLoading ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                ) : "OK"}</button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={this.BacktoFile}
                                    style={{ width: '107px', fontSize: '14px', border: '1px solid black', height: '43px' }}
                                > Back To File</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* OTHER REASON MODAL */}
                <div className="modal hide fade in" id="another-reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                            <h5 style={{ marginTop: '31px', textAlign: 'center' }}>Please Type a Reason To Close The File.No: {localStorage.getItem("currentfileId")} </h5>
                            <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>

                                <div className="form-group" style={{ width: '98%', margin: 'auto' }}>
                                    <textarea
                                        className="form-control"
                                        placeholder="Type Your Reason"
                                        name="outreason" onChange={this.onchange} />
                                    {this.state.selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => this.outimeGet()}
                                    style={{ width: '76px', fontSize: '17px' }}
                                    disabled={this.state.isLoading}
                                > {this.state.isLoading ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                ) : "OK"}</button>
                                <button
                                    type="button"
                                    className="btn btn-outline"

                                    onClick={() => this.previousPop()}
                                    style={{ width: '76px', fontSize: '17px', border: '1px solid black' }}
                                > Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default RectifyCategorymanagement;
